// extracted by mini-css-extract-plugin
module.exports = {"dimensions":"Dimensions_dimensions__1kI9s","headers":"Dimensions_headers__1ATnI","values":"Dimensions_values__1m6GG"};